/* eslint-disable max-len */
/** @jsx jsx */
import React, { Dispatch } from 'react';
import { isIPad13, isTablet } from "react-device-detect";
import { Link } from 'react-router-dom';
import FormField from 'components/atoms/Form/FormField';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import Button, { PrimaryButton, SecondaryButton } from 'components/atoms/Button';
import FormTitle from 'components/atoms/Form/FormTitle';
import StaffDomain from 'domain/staff';
import ConfirmActionModal, { ActionType } from 'components/organismos/ConfirmActionModal';
import DataTable from 'components/organismos/DataTable/DataTable';
import { Column } from 'react-table';
import { OrganizationDataStaffDomain } from 'domain/master/general/organizationDataStaff';
import { getOrganizationInfo } from 'api/organization';
import moment from 'moment';
import { useAffiliationForm } from './hooks';
import { TablItem } from 'components/atoms/TabBar';
import CalendarForm from 'components/molecules/CalendarForm';
import { css, jsx } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import useStaffList from 'components/pages/master/general/staff/StaffsPage/hooks';
import { useStaffDelete } from '../StaffListTable/hooks';
import OrganizationManagerEdit from 'components/organismos/master/general/staff/OrganizationAddModal/OrganizationManagerEdit';
import OrganizationAddModal from 'components/organismos/master/general/staff/OrganizationAddModal';
import IconLabelButton from 'components/molecules/IconLabelButton';
import BodyText from "components/atoms/BodyText";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import SelectForm from 'components/molecules/SelectForm';
import VerticalLabelFormLayout from 'components/atoms/Form/VerticalLabelFormLayout';
import FormLabel from 'components/atoms/Form/FormLabel';
import Calendar from 'components/molecules/CalendarV1';

type SelectType = 'staff' | 'affiliation' | 'employment' | 'laborCost' | 'workPattern' | 'longTermCareandNurse';

const SelectType: { [key in SelectType]: SelectType } = {
  staff: 'staff',
  affiliation: 'affiliation',
  employment: 'employment',
  laborCost: 'laborCost',
  workPattern: 'workPattern',
  longTermCareandNurse: 'longTermCareandNurse'
};

const styles = {
  form: css({
    maxWidth: '600px',
    margin: '0 auto',
    padding: '30px',
    paddingLeft: '15px',
    paddingTop: 0
  }),
  table: css({
    width: '100%'
  }, css`
    tr td{
      text-align:left;
    }
    tr th {
      text-align:center;
    }
    tr td: first-child {
      text-align:center;
    }
  `),
  table1: css(css`
    white-space: nowrap;
    overflow-x: auto;
    padding-bottom: 0px;
    tr td {
      text-align:left;
    }
    tr th {
      text-align:center;
    }
    tr td: first-child {
      text-align:center;
    }
  `),
  note: css({
    margin: '0px 10px 20px',
    paddingLeft: '30px',
    display: 'block'
  }),
  buttonAdd: css({
    maxWidth: '190px',
    marginLeft: '25px',
    marginTop: '15px'
  }),
  buttonSubmit: css({
    margin: '0 auto'
  }),
  centerBox: css({
    justifyContent: 'center'
  })
};

const AffiliationInfoForm: React.FC<{
  initialStaffDomain?: StaffDomain;
  isEditMode?: boolean;
  tabItems: TablItem[];
  setInitialStaffDomain: Dispatch<React.SetStateAction<StaffDomain>>;
  setSelectType: Dispatch<React.SetStateAction<SelectType>>;
  setTabItems: Dispatch<React.SetStateAction<TablItem[]>>;
  setOrgTargetDate?: React.Dispatch<React.SetStateAction<Date>>;
  organizationOptions: Array<any>;
  executiveOptions: Array<any>;
  isDisabledInfo?:boolean
  setIsLoading?: Dispatch<React.SetStateAction<boolean>>;
}> = ({
  initialStaffDomain, isEditMode = false, tabItems,
  setInitialStaffDomain, setSelectType, setTabItems,
  setOrgTargetDate,
  organizationOptions, executiveOptions,
  isDisabledInfo = false,
  setIsLoading
}) => {
    const {
      formik,
      confirmModalOpen,
      closeConfirmModal,
      deleteOrganizationManager,
      setOrganizationManager,
      setOpenManagerAddModal,
      openManagerAddModal,
      addManager,
    } = useAffiliationForm(
      initialStaffDomain,
      isEditMode,
      setIsLoading
    );


    const columns: Array<Column<OrganizationDataStaffDomain>> = React.useMemo(() => [
      {
        Header: '異動日',
        accessor: 'applyStartDateStr',
      },
      {
        Header: '組織コード',
        accessor: 'orgCode',
      },
      {
        Header: '組織名',
        accessor: 'orgName',
      },
      {
        Header: '役職コード',
        accessor: 'executiveCode',
      },

      {
        Header: '役職名',
        accessor: 'executiveName',
      },

    ], []);

    const { fetchData } = useStaffList();
    const { setDeleteTargetStaff, isOpenDeleteModal, setIsOpenDeleteModal, closeDeleteModal, onSubmitDeleteStaff } = useStaffDelete(fetchData, setIsLoading);

    return (
      <React.Fragment>
        {formik.values.organizationDataList
          && formik.values.organizationDataList.length !== 0 && (
            <div css={styles.table1} className="table-bordered table-padding">
              <DataTable
                classNameParrant="border-left-right"
                className="table-no-border-left-right"
                columns={columns}
                data={formik.values.organizationDataDomainList}
                isHiddenPagination={false}
                minWidth="100%"
              />
            </div>
          )}

        <form onSubmit={formik.handleSubmit} css={styles.form}>
          <FormTitle
            title="基本情報"
            bold={true}
            customStyle={css({marginLeft: 0, paddingTop: 0, paddingLeft: 0})}
          />
          <FormField>
            <VerticalLabelFormLayout 
             label={(
              <FormLabel
                label="異動日"
                required={true}
              /> 
            )}
            input={(
              <Calendar
              date={formik.values.orgApplyDate}
              setDate={(date) => {
                if(date){
                  if (setOrgTargetDate) {
                    setOrgTargetDate(date);
                  }
                  formik.setFieldValue('orgApplyDate', date);
                }
              }}
              readOnly={isDisabledInfo}
              />
            )}
              errorMsg={formik.errors.orgApplyDate}
            />
            {/* <CalendarForm
              dateFormat="YYYY/MM/DD"
              label="異動日"
              date={formik.values.orgApplyDate}
              changeDate={(date: Date) => {
                if (setOrgTargetDate) {
                  setOrgTargetDate(date);
                }
                formik.setFieldValue('orgApplyDate', date);
              }}
              required={true}
              errorMsg={formik.errors.orgApplyDate}
              readOnly={isDisabledInfo}
            /> */}
            
          </FormField>

          <FormField customStyle={css(isIPad13 || isTablet ? {width: '550px'} : {})} displayBlock={true}>
            <SelectForm
              label="組織"
              name="organization"
              value={formik.values.orgCode}
              setValue={(val: string) => {
                formik.values.orgCode = val;
                formik.setFieldValue('orgCode', val);
                setInitialStaffDomain(formik.values);
              }}
              options={organizationOptions}
              note={isEditMode ? ' 組織を変更すると、勤務パターンが削除され、再登録が必要となります。' : ''}
              errorMsg={formik.errors.orgCode}
              required={true}
              disable={isDisabledInfo}
              isDisplayBlock={true}
            />
          </FormField>

          <FormField customStyle={css(isIPad13 || isTablet ? {width: '550px'} : {})} displayBlock={true}>
            <SelectForm
              label="役職"
              name="executiveId"
              value={formik.values.executiveId}
              setValue={(val: string) => { formik.setFieldValue('executiveId', val); }}
              options={executiveOptions}
              disable={isDisabledInfo}
              isDisplayBlock={true}
            />
          </FormField>
        </form>
        <BodyText customStyle={styles.note}>組織勤怠責任者の場合、マネージャー権限を付与してください。</BodyText>
        <FlexBox>
          <FlexBoxItem basis="100%">
            <div className="table-padding">
            <table className="table-bordered" css={styles.table}>
              <thead>
                <tr>
                  <th style={{width: '100px'}}></th>
                  <th style={{width: '180px'}}>組織</th>
                  <th style={{width: '180px'}}>区分</th>
                  <th style={{width: '150px'}}>期間</th>
                </tr>
              </thead>
              <tbody>
                {
                  formik.values.managerDomainList ? formik.values.managerDomainList.map((manager, index) => (
                    <OrganizationManagerEdit
                      key={index.toString()}
                      manager={manager}
                      deleteManager={deleteOrganizationManager(index)}
                      setManager={setOrganizationManager(index)}
                    />
                  )) : <tr><th colSpan={3}><BodyText>Loading...</BodyText></th></tr>
                }
              </tbody>
            </table>
            </div>
          </FlexBoxItem>
        </FlexBox>
        <div css={styles.buttonAdd}>
          <IconLabelButton onClick={() => setOpenManagerAddModal(true)} iconType="addCircle" text="マネージャー権限追加" />
        </div>
        <FormField>
          <OrganizationAddModal
            open={openManagerAddModal}
            openHandler={setOpenManagerAddModal}
            addOrganization={addManager}
          />
        </FormField>

        <FormSubmitArea customStyle={css({ padding: '15px auto' })}>
          <div style={{ marginRight: '12px', textAlign: 'center' }}>
            <FlexBox customStyle={styles.centerBox}>
              {/* {!isDisabledInfo? */}
              <Button
                text={isEditMode ? '所属情報を登録' : '登録'}
                onClick={formik.handleSubmit}
                minWidth="150px"
              />
              {/* :''} */}
              {
                isEditMode &&!isDisabledInfo?
                  <div style={{ marginLeft: '12px', textAlign: 'center' }}>
                    <SecondaryButton
                      minWidth="150px"
                      text='削除'
                      onClick={() => {
                        setIsOpenDeleteModal(true);
                        setDeleteTargetStaff(formik.values)
                      }}
                    />
                  </div>
                  : ''
              }
              {!isEditMode && (
                <div style={{ marginLeft: '12px', textAlign: 'center' }}>
                  <Button
                    text="雇用情報の入力へ"
                    onClick={() => {
                      if (formik.values.orgApplyDate && formik.values.orgCode) {
                        formik.values.empApplyDate = formik.values.hireDate;
                        getOrganizationInfo(formik.values.orgCode, moment(formik.values.hireDate).format('YYYY-MM-DD')).then((response: any) => {
                          if (response.employmentId) {
                            formik.setFieldValue('employmentId', response.employmentId);
                          } else {
                            formik.setFieldValue('employmentId', '');
                          }

                          if (tabItems.length <= 2) {
                            setInitialStaffDomain(formik.values);
                            setTabItems([
                              {
                                value: SelectType.staff,
                                display: 'スタッフ情報',
                              },
                              {
                                value: SelectType.affiliation,
                                display: '所属情報',
                              },
                              {
                                value: SelectType.employment,
                                display: '雇用情報',
                              },
                            ]);
                          }
                          setSelectType(SelectType.employment);
                        });
                      } else {
                        formik.validateForm();
                      }
                    }}
                  />
                </div>
              )}
            </FlexBox>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Link to="/staffs">
              <PrimaryButton
                text="スタッフ一覧に戻る"
                ghost={true}
                minWidth="150px"
              />
            </Link>
          </div>
        </FormSubmitArea>
        {/* 登録内容確認モーダル */}
        <ConfirmActionModal
          open={confirmModalOpen}
          closeHandler={closeConfirmModal}
          onSubmit={formik.handleSubmit}
          actionType={isEditMode ? ActionType.UPDATE : ActionType.CREATE}
        />
        <ConfirmActionModal
          open={isOpenDeleteModal}
          closeHandler={closeDeleteModal}
          onSubmit={onSubmitDeleteStaff}
          actionType={ActionType.DELETE}
          typeSubmit="reject"
        />
      </React.Fragment>
    );
  };

export default AffiliationInfoForm;
